export default __webpack_public_path__ + "static/media/bg.730ade7d.webp";